import React from 'react';
import CloseButton from './components/close-button/CloseButton';
import AnnouncementSvg from './components/AnnouncementSvg.js';
import custom from './AlertBanner.scss';
import { navigate } from '../../services/web.navigation';

const AlertBanner = ({ redirectTo, closeButton, title, ...props }) => {
  const redirectBasedOnPendings = path => navigate(`#mfe${path}`);

  return (
    <div
      className={custom.wrapper__banner__pending}
      //  onClick={() => redirectBasedOnPendings(redirectTo)}
      closeButton={closeButton}
      {...props}
    >
      <AnnouncementSvg className="AlertBanner__iconSize" />
      <span
        className={custom.styled__text__banner}
        aria-hidden="true"
        onClick={() => redirectBasedOnPendings(redirectTo)}
      >
        {title && <span className={custom.styled__title__banner}>{title}</span>}
      </span>
      <div className={custom.AlertBanner__closeIconPlaceHolder}>
        <CloseButton onClick={closeButton.onClick} closeButtonLabel={closeButton.label} />
      </div>
    </div>
  );
};

export default AlertBanner;
